import { render, staticRenderFns } from "./AUC.vue?vue&type=template&id=5580048e&scoped=true"
import script from "./AUC.vue?vue&type=script&lang=js"
export * from "./AUC.vue?vue&type=script&lang=js"
import style0 from "./AUC.vue?vue&type=style&index=0&id=5580048e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5580048e",
  null
  
)

export default component.exports